/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ShadowAccountAmiInfo { 
    /**
     * AMI ID
     */
    ami_id?: string;
    /**
     * AMI Name
     */
    ami_name?: string;
    /**
     * AMI Owner Id
     */
    ami_owner_id?: string;
    /**
     * AMI Creation date
     */
    create_date?: Date;
    /**
     * Status of the AMI
     */
    status?: string;
    /**
     * Public or Private
     */
    visibility?: string;
}

